var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClasses(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92487 29H27.0609C28.0233 29 28.9858 28 28.9858 27V14L27.0609 16V27H11.6619C11.6244 27 10.737 27 10.6995 27C10.6518 27 9.78614 27.0014 9.73705 27H4.92487V5H16.4741L18.6593 3H4.92487C3.96244 3 3 4 3 5V27C3 28 3.96244 29 4.92487 29Z",
    fill: "#747474"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.468 3.88129C23.639 2.70971 25.5374 2.70971 26.7084 3.88129L28.1218 5.2955C29.2927 6.46707 29.2927 8.36657 28.1218 9.53814L14.6941 22.9732L8.33364 23.6803L9.04036 17.3163L22.468 3.88129ZM24.5882 4.58839L27.4151 7.41682L24.5882 10.2452L21.7613 7.41682L24.5882 4.58839ZM23.1748 11.6595L20.3479 8.83104L11.4471 17.7367L10.7403 21.2723L14.2739 20.5651L23.1748 11.6595Z",
    fill: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasses);
export default __webpack_public_path__ + "static/media/classes.7403cf5572f14e55bac4dda203f56dd7.svg";
export { ForwardRef as ReactComponent };